import * as actionTypes from "./actionTypes";

export const actions = {
  getProductSuccess: (payload) => ({
    type: actionTypes.GET_PRODUCT_SUCCESS,
    payload,
  }),
  getProductRequest: (payload) => ({
    type: actionTypes.GET_PRODUCT_REQUEST,
    payload,
  }),
  getSearchProductsRequest: (searchTerm) => ({
    type: actionTypes.GET_SEARCHED_PRODUCTS_REQUEST,
    searchTerm,
  }),
  getSearchProductsSuccess: (products) => ({
    type: actionTypes.GET_SEARCHED_PRODUCTS_SUCCESS,
    products,
  }),
  resetSearchProducts: () => ({
    type: actionTypes.RESET_SEARCHED_PRODUCTS,
  }),
  fetchRequestForProductRequest: () => ({
    type: actionTypes.FETCH_REQUEST_FOR_PRODUCT_REQUEST,
  }),
  fetchRequestForProductSuccess: (productRequests) => ({
    type: actionTypes.FETCH_REQUEST_FOR_PRODUCT_SUCCESS,
    productRequests,
  }),
  resetProductRequests: () => ({
    type: actionTypes.RESET_PRODUCT_REQUESTS,
  }),
  requestForOosSkus: () => ({
    type: actionTypes.GET_OOS_SKUS_REQUEST,
  }),
};

const initialState = {
  productList: {},
  numberOfProducts: {},
  offset: {},
  limit: 10,
  productsBySearch: [],
  productRequests: [],
  isFetchingProducts: false,
  isFetchingProductRequests: false,
  oosProducts: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PRODUCT_REQUEST: {
      const { replace = false, isPulled = false } = action.payload;
      let loading = true;

      if (replace && !isPulled) {
        loading = false;
      }

      return {
        ...state,
        isFetchingProducts: loading,
      };
    }
    case actionTypes.GET_PRODUCT_SUCCESS: {
      return {
        ...state,
        productList: { ...state.productList, ...action.products },
        numberOfProducts: { ...state.numberOfProducts, ...action.productCount },
        offset: { ...state.offset, ...action.offset },
        isFetchingProducts: false,
      };
    }

    case actionTypes.GET_SEARCHED_PRODUCTS_SUCCESS: {
      return {
        ...state,
        productsBySearch: action.products,
      };
    }

    case actionTypes.RESET_SEARCHED_PRODUCTS: {
      return {
        ...state,
        productsBySearch: [],
      };
    }

    case actionTypes.FETCH_REQUEST_FOR_PRODUCT_REQUEST: {
      return {
        ...state,
        isFetchingProductRequests: true,
      };
    }

    case actionTypes.FETCH_REQUEST_FOR_PRODUCT_SUCCESS: {
      return {
        ...state,
        productRequests: action.productRequests,
        isFetchingProductRequests: false,
      };
    }

    case actionTypes.RESET_PRODUCT_REQUESTS: {
      return {
        ...state,
        productRequests: [],
      };
    }

    case actionTypes.GET_OOS_SKUS_SUCCESS: {
      return {
        ...state,
        oosProducts: action.payload,
      };
    }

    case actionTypes.RESET_PRODUCTS_STATE: {
      return initialState;
    }
  }
  return state;
};

reducer.initialState = initialState;

export default reducer;
